import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";

import WrappedApp from "./App";
import "./styles/style.css";
import store from "./redux/store";
import { NEW_PROJECT_ACCESS_KEY } from "./utils/constant";

const container = document.getElementById("root");
const params = new URLSearchParams(window.location.search);
const accessKey = params.get("access_key");

const root = createRoot(container);

root.render(
  <Provider store={store}>
 
      <WrappedApp />
  </Provider>
);

reportWebVitals();
